import React from "react";

// the round VIKAS button; opens or closes the chat drawer
export function VikasBubble({ open, onToggle }) {
  return (
    <button type="button" className={`vbubble${open ? " on" : ""}`} onClick={onToggle} aria-label={open ? "Close VIKAS chat" : "Ask VIKAS"}
      aria-expanded={open} data-testid="vikas-bubble">
      <span className="vb-mark" aria-hidden="true">VIKAS</span>
      <span className="vb-tip" role="tooltip">Ask VIKAS</span>
    </button>
  );
}
